function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  className: "st0",
  d: "M11.1,9.7c1.2-0.9,2.2-1.9,2.8-3c0.7-1.1,1-2.1,1-3.2c0-0.5-0.1-0.9-0.3-1.2C14.5,2.1,14.3,2,14,2 c-0.8,0-1.5,0.7-2.1,2C11.3,5.3,11,6.8,11,8.5c0,0.2,0,0.5,0,0.7C11,9.3,11,9.5,11.1,9.7z M1,19v-2h2v2H1z M5,19v-2h2v2H5z M9,19v-2 h2v2H9z M13,19v-2h2v2H13z M17,19v-2h2v2H17z M1.4,15L0,13.6L1.6,12L0,10.4L1.4,9L3,10.6L4.6,9L6,10.4L4.4,12L6,13.6L4.6,15L3,13.4 L1.4,15z M12.4,14c-0.5,0-1-0.1-1.4-0.3c-0.4-0.2-0.8-0.5-1.1-0.9c-0.4,0.2-0.8,0.4-1.3,0.6c-0.4,0.2-0.9,0.4-1.4,0.6l-0.7-1.9 c0.5-0.2,0.9-0.3,1.3-0.5c0.4-0.2,0.8-0.4,1.2-0.6C9.1,10.6,9.1,10.2,9,9.7C9,9.3,9,8.8,9,8.3c0-2.4,0.5-4.4,1.4-6S12.5,0,14,0 c0.9,0,1.6,0.3,2.1,1c0.5,0.6,0.8,1.5,0.8,2.7c0,1.4-0.5,2.8-1.4,4.2c-0.9,1.4-2.2,2.7-3.8,3.8c0.1,0.1,0.2,0.2,0.4,0.3 c0.1,0.1,0.3,0.1,0.4,0.1c0.4,0,0.9-0.3,1.5-0.8c0.6-0.6,1.1-1.3,1.6-2.2l1.8,0.9c-0.1,0.3-0.2,0.6-0.3,1c-0.1,0.4-0.1,0.8,0,1.1 c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.5-0.4,0.7-0.8L20,12c-0.4,0.6-0.9,1.1-1.5,1.4c-0.6,0.4-1.1,0.6-1.6,0.6c-0.3,0-0.7-0.1-0.9-0.3 c-0.3-0.2-0.5-0.5-0.7-1c-0.5,0.4-0.9,0.7-1.4,0.9C13.4,13.9,12.9,14,12.4,14z"
});

var SvgSign = function SvgSign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sign.77bbc148.svg";
export { ForwardRef as ReactComponent };